import request from '@/utils/request';
export function transformItem2Dto(item) {
  const dto = {
    userID: item.id,
    ...item
  };
  delete dto.id;
  if (!item.reference || !item.reference.trim()) {
    dto.reference = null;
  }
  const roles = [];
  if (item.roles) {
    item.roles.forEach(role => {
      const roleDto = {
        roleID: role.id,
        ...role
      };
      delete roleDto.id;
      roles.push(roleDto);
    });
  }
  dto.roles = roles;

  const companies = [];
  if (item.companies) {
    item.companies.forEach(company => {
      const companyDto = {
        companyID: company.id
      };
      delete companyDto.id;
      companies.push(companyDto);
    });
  }
  dto.companies = companies;

  return dto;
}

function transformDto2Item(dto) {
  const item = {
    id: dto.userID,
    ...dto
  };
  delete item.userID;

  const roles = [];
  if (dto.roles) {
    dto.roles.forEach(roleDto => {
      const role = {
        id: roleDto.roleID,
        ...roleDto
      };
      delete role.roleID;
      roles.push(role);
    });
  }
  item.roles = roles;

  const companies = [];
  if (dto.companies) {
    dto.companies.forEach(companyDto => {
      const company = {
        id: companyDto.companyID,
        ...companyDto
      };
      delete company.companyID;
      companies.push(company);
    });
  }
  item.companies = companies;

  return item;
}

export const apiOverrides = { transformItem2Dto, transformDto2Item };

function apiSelfUpdate(user) {
  return request({
    data: transformItem2Dto(user),
    method: 'put',
    url: '/userprofile'
  });
}
function apiFetchUser(id, withPermissions, withDomains) {
  return request({
    method: 'get',
    params: {
      withDomains: withDomains,
      withPermissions: withPermissions
    },
    url: '/standardUser/' + id.toString()
  });
}

function apiAdminUpdate(user) {
  return request({
    data: transformItem2Dto(user),
    method: 'put',
    url: '/standardUser/'
  });
}
export const storeExtensions = {
  actions: {
    update({ dispatch }, user) {
      return apiAdminUpdate(user);
    },
    updateSelf({ dispatch }, user) {
      return apiSelfUpdate(user);
    },
    fetchUser({ dispatch }, { id, withPermissions, withDomains } = {}) {
      return apiFetchUser(id, withPermissions, withDomains);
    }
  }
};
